module.exports = __webpack_public_path__ + "img/watch-baseball.1cefdf44.svg";